import React, { useEffect, useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Line } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

function Graph({ chartData, transitionIndex }: any) {
  const chartRef = useRef<any>(null)

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy()
      }
    }
  }, [])

  if (!chartData) return null

  const options: any = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: 'red',
        font: { size: 14, weight: '500' },
        formatter: (value: any, context: any) =>
          context.dataIndex === transitionIndex ? 'Inns Over' : ''
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const datapoint = context.dataset.data[context.dataIndex]
            return datapoint.isWicket ? `W-${datapoint?.player}` : ''
          }
        }
      }
    },
    scales: {
      x: { title: { display: true, text: 'Overs' } },
      y: { title: { display: true, text: 'Win Percentage' } }
    },
    elements: {
      point: {
        radius: (context: any) => (context.dataset.data[context.dataIndex]?.isWicket ? 6 : 0),
        backgroundColor: (context: any) =>
          context.dataset.data[context.dataIndex]?.isWicket ? 'red' : 'gray'
      },
      line: { borderColor: '#4A6E31' }
    }
  }

  return <Line ref={chartRef} options={options} data={chartData} />
}

export default Graph
